<template>
  <article>
    <section class="w-full">
      <div class="banner w-full lg:h-18 h-60 relative">
        <div class="flex items-center flex-column w-full h-full">
          <div class="container mx-auto">
            <div class="flex flex-col items-center w-full container">
              <divider-component>Foto's</divider-component>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="flex justify-center mt-10">
      <tabs-component :current-tab="activePage" @toggle-page="togglePage($event)"></tabs-component>
    </section>
    <section class="lg:pt-16 lg:px-32">
      <gallery-component v-if="activePage === 0" :pictures="tabOnePictures"></gallery-component>
      <gallery-component v-if="activePage === 1" :pictures="tabTwoPictures"></gallery-component>
      <gallery-component v-if="activePage === 2" :pictures="tabThreePictures"></gallery-component>
    </section>
  </article>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import DividerComponent from '@/components/util/Divider.component.vue';
import GalleryComponent from '@/components/photos/Gallery.component.vue';
import TabsComponent from '../components/util/Tabs.component.vue';

export default defineComponent({
  name: 'Photo-page',

  components: { DividerComponent, GalleryComponent, TabsComponent },
  setup() {
    const activePage = ref(0);

    function togglePage(newPage: number) {
      activePage.value = newPage;
    }

    const tabOnePictures: Array<string> = [
      'gallery-image9.jpg',
      'gallery-image1.jpeg',
      'gallery-image2.jpeg',
      'gallery-image3.jpeg',
      'gallery-image4.jpeg',
      'gallery-image5.jpeg',
    ];
    const tabTwoPictures: Array<string> = [
      'gallery-image1.jpeg',
      'gallery-image2.jpeg',
      'gallery-image3.jpeg',
      'gallery-image4.jpeg',
      'gallery-image5.jpeg',
      'gallery-image6.jpeg',
      'gallery-image7.jpeg',
      'gallery-image8.jpeg',
    ];
    const tabThreePictures: Array<string> = [''];

    return {
      activePage,
      togglePage,
      tabOnePictures,
      tabTwoPictures,
      tabThreePictures,
    };
  },
});
</script>

<style lang="scss" scoped></style>
